import React, { useEffect, useState } from 'react';
import UserHeader from './UserHeader';
import UserSidebar from './UserSidebar';
import MobileMenu from './MobileMenu';
import { useAuth } from '../context/AuthContext';
import { EsosaProvider } from './AIAssistant/EsosaContext';
import EsosaAssistant from './AIAssistant/EsosaAssistant';
interface UserLayoutProps {
  children: React.ReactNode;
}
const UserLayout: React.FC<UserLayoutProps> = ({
  children
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const {
    logout
  } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // Set initial sidebar state based on screen size and saved preference
  useEffect(() => {
    const savedSidebarState = localStorage.getItem('sidebarOpen');
    const handleResize = () => {
      // Default to closed on smaller screens, open on larger screens
      const shouldBeOpen = window.innerWidth >= 1280;
      setIsSidebarOpen(savedSidebarState !== null ? savedSidebarState === 'true' : shouldBeOpen);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const toggleSidebar = () => {
    const newState = !isSidebarOpen;
    setIsSidebarOpen(newState);
    localStorage.setItem('sidebarOpen', String(newState));
  };
  const handleLogout = () => {
    logout();
    window.location.href = '/login';
  };
  return <EsosaProvider data-id="element-760">
      <div className="flex h-screen bg-gray-50" data-id="element-761">
        {/* Sidebar */}
        <UserSidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} data-id="element-762" />
        {/* Main Content */}
        <div className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ${isSidebarOpen ? 'lg:ml-0' : 'lg:ml-0'}`} data-id="element-763">
          <UserHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} onMobileMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)} isMobileMenuOpen={isMobileMenuOpen} data-id="element-764" />
          {/* Mobile Menu */}
          <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} onLogout={handleLogout} data-id="element-765" />
          {/* Page Content */}
          <main className="flex-1 overflow-y-auto bg-gray-50" data-id="element-766">{children}</main>
          {/* AI Assistant */}
          <EsosaAssistant data-id="element-767" />
        </div>
      </div>
    </EsosaProvider>;
};
export default UserLayout;